import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const HiddenLabel = styled.span`
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const PositionedTooltip = styled(Tooltip).attrs({
  position: "top",
  zIndex: 1001
})`
  vertical-align: unset;
`;

export const DesktopTooltip = styled(PositionedTooltip).attrs({
  width: "300px"
})`
  @media screen and (max-width: ${smallScreen}px) {
    display: none;
    visibility: hidden;
  }
`;

export const MobileTooltip = styled(PositionedTooltip).attrs({
  hasCloseButton: true,
  trigger: "click",
  width: "185px"
})`
  display: none;
  visibility: hidden;

  @media screen and (max-width: ${smallScreen}px) {
    display: inline-block;
    visibility: visible;
  }
`;

export const TooltipContent = styled.div`
  padding: 0 5px;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 0;
  }
`;

export const TooltipTitle = styled(Text).attrs({
  type: "sm"
})`
  font-weight: bold;
  margin-bottom: 5px;
`;

export const Trigger = styled.i.attrs({
  className: "fa fa-info-circle"
})`
  color: ${colors.textSecondary};
  display: inline-block;
  font-size: 14px;
  position: relative;

  &:hover {
    cursor: pointer;
  }
`;
